import { useQuery } from '@tanstack/react-query'

import { axiosInstance } from '../../helpers'
import { ApartmentTour, LeadTourStatus } from '../../models/Outreach/types'
import { useUser } from '../useUser'

const TOURS_KEY = 'apartment-tours'

export interface UseToursParams {
    startsAfter?: string
    startsBefore?: string
    status?: LeadTourStatus | LeadTourStatus[] | string
    givenById?: number
}

export const useTours = (params?: UseToursParams) => {
    const { workspaceUser } = useUser()
    const apartmentId = workspaceUser?.active_workspace?.id
    const isApartment =
        workspaceUser?.active_workspace?.company_type === 'APARTMENT'

    const statusParam = Array.isArray(params?.status)
        ? params?.status.join(',')
        : params?.status

    const { data: tours, isLoading, error, refetch } = useQuery<
        ApartmentTour[],
        Error
    >({
        queryKey: [
            TOURS_KEY,
            apartmentId,
            params?.startsAfter,
            params?.startsBefore,
            statusParam,
            params?.givenById,
        ],
        queryFn: async () => {
            const queryParams = new URLSearchParams()
            if (params?.startsAfter) {
                queryParams.set('starts_after', params.startsAfter)
            }
            if (params?.startsBefore) {
                queryParams.set('starts_before', params.startsBefore)
            }
            if (statusParam) {
                queryParams.set('status', statusParam)
            }
            if (params?.givenById != null) {
                queryParams.set('given_by_id', String(params.givenById))
            }
            const qs = queryParams.toString()
            const url = qs ? `/outreach/tours/?${qs}` : '/outreach/tours/'
            const res = await axiosInstance.get(url)
            const data = res.data
            if (Array.isArray(data)) return data as ApartmentTour[]
            if (data && Array.isArray(data.results)) {
                return data.results as ApartmentTour[]
            }
            return []
        },
        enabled: isApartment && !!apartmentId,
        keepPreviousData: true,
        refetchOnMount: true,
        refetchOnWindowFocus: false,
    })

    return {
        tours: tours ?? [],
        isLoading,
        error,
        refetch,
    }
}
